import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectBuyers,
  selectError,
  selectIsLoading,
  selectIsLoadingBuyers,
  selectIsLoadingResults,
  selectIsRequesting,
  selectReports,
  selectResults,
  selectStatuses,
  selectSurveyPerformanceError,
} from './selectors/report.selectors';

@Injectable({ providedIn: 'root' })
export class ReportSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly reports = this._store.selectSignal(selectReports);
  public readonly statuses = this._store.selectSignal(selectStatuses);
  public readonly isLoading = this._store.selectSignal(selectIsLoading);
  public readonly isRequesting = this._store.selectSignal(selectIsRequesting);
  public readonly error = this._store.selectSignal(selectError);

  public readonly surveyPerformanceResults =
    this._store.selectSignal(selectResults);
  public readonly surveyPerformanceBuyers =
    this._store.selectSignal(selectBuyers);
  public readonly isSurveyPerformanceLoadingResults = this._store.selectSignal(
    selectIsLoadingResults,
  );
  public readonly isSurveyPerformanceLoadingBuyers = this._store.selectSignal(
    selectIsLoadingBuyers,
  );
  public readonly surveyPerformanceError = this._store.selectSignal(
    selectSurveyPerformanceError,
  );
}
